{
    "FINISHED": "Finalizado",
    "IN_PROGRESS": "Em andamento",
    "DOCTOR": "Médico",
    "PATIENT": "Paciente"
}